const items = ["Tráfego Pago", "SEO", "Social Media", "Consultoria", "Performance", "Crescimento"];

const Half = ({ hidden }) => (
  <div className="marquee-half" aria-hidden={hidden}>
    {items.map((item, index) => (
      <span key={item} className={index % 2 ? "outline" : ""}>{item}<i>✦</i></span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="marquee" data-testid="editorial-marquee">
    <div className="marquee-track"><Half hidden={false} /><Half hidden /></div>
  </section>
);
